import { IProcessedMeasurement, TMeasurementValue } from 'app/types/measurement';
import { TMeasurementAlert } from 'app/types/alert';
import { TMeasurementResponse } from 'app/_modules/pathways/entities';
import { serializeSnakeToCamel } from '@shared/utils/serializer';

const SCALAR_MEASUREMENT_KEY: Record<string, string> = {
  heart_rate: 'heart_rate',
  temperature: 'temperature',
  weight: 'weight',
  spo2: 'saturation',
  spirometry: 'pef',
};

export const toMeasurementResponse = (measurement: IProcessedMeasurement): TMeasurementResponse => {
  const measurementValue =
    typeof measurement.value === 'object' && measurement.value !== null
      ? measurement.value
      : { [SCALAR_MEASUREMENT_KEY[measurement.type] ?? measurement.type]: measurement.value };

  return {
    measurement: measurementValue,
    timestamp: measurement.measuredAt,
    type: measurement.type,
    telemonitoring_pathway_id: '',
    alert: measurement.alert,
  } as TMeasurementResponse;
};

export const formatMeasurementValue = (value: TMeasurementValue, type: string): string => {
  if (typeof value === 'number') {
    switch (type) {
      case 'heart_rate':   return `${value} bpm`;
      case 'temperature':  return `${value}°C`;
      case 'weight':       return `${value} kg`;
      case 'spo2':         return `${value}%`;
      case 'spirometry':   return `${value} L/m`;
      default:             return value.toString();
    }
  }
  if (typeof value === 'boolean') return value ? 'AFib detected' : 'Normal rhythm';
  if (typeof value === 'object' && value !== null && 'systolic' in value && 'diastolic' in value)
    return `${value.systolic}/${value.diastolic} mmHg`;
  return String(value);
};

export const normalizeAlert = (raw: unknown): TMeasurementAlert | null => {
  if (!raw || typeof raw !== 'object') return null;
  return serializeSnakeToCamel<TMeasurementAlert>(raw);
};
